export default __webpack_public_path__ + "static/media/rescheduled_appointment.a3fb1520.svg";